import { createRoute, useNavigate } from "@tanstack/react-router";
import { OwnerDetailPage } from "@/components/owners/owner-detail-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/owner-detail/$ownerId",
  validateSearch: (search: Record<string, unknown>): { from?: string; tab?: string } => ({
    from: (search.from as string) || undefined,
    tab: (search.tab as string) || undefined,
  }),
  loader: async ({ params }) => {
    const [ownerRes, accessRes] = await Promise.all([
      fetch(`/api/owners/${params.ownerId}`),
      fetch(`/api/org-chart/can-view/${params.ownerId}`),
    ]);
    if (!ownerRes.ok) throw new Error("Owner not found");
    const data = await ownerRes.json();
    const access = accessRes.ok ? await accessRes.json() : { canView: false, isAdmin: false };
    return { owner: data.owner, canView: access.canView, isAdmin: access.isAdmin };
  },
  component: OwnerDetailGuard,
});

function OwnerDetailGuard() {
  const navigate = useNavigate();
  // biome-ignore lint/suspicious/noExplicitAny: route type not yet in TanStack Router's generated types
  const { canView, isAdmin } = Route.useLoaderData() as any;

  if (!canView) {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <OwnerDetailPage readOnly={!isAdmin} />;
}
